import { render, staticRenderFns } from "./shsj.vue?vue&type=template&id=60c4195e&scoped=true&"
import script from "./shsj.vue?vue&type=script&lang=js&"
export * from "./shsj.vue?vue&type=script&lang=js&"
import style0 from "./shsj.vue?vue&type=style&index=0&id=60c4195e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4195e",
  null
  
)

export default component.exports